import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full py-16 md:py-24 overflow-hidden">
      {/* Background */}
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20abstract%20gradient%20background%20with%20flowing%20organic%20shapes%20in%20soft%20orange%20and%20cream%20tones%2C%20minimalist%20geometric%20composition%2C%20modern%20digital%20art%2C%20clean%20and%20airy%20aesthetic%2C%20no%20text%2C%20smooth%20curves&width=1920&height=800&seq=cta-bg-2026&orientation=landscape"
        alt="加入香蕉视频"
        className="absolute inset-0 w-full h-full object-cover"
        title="加入香蕉视频创作平台"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-black/40"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-bold text-background-50 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
          准备好开启你的创作之旅了吗？
        </h2>
        <p className="text-sm md:text-base text-background-50/80 mb-8 max-w-lg mx-auto">
          加入香蕉视频大家庭，与500万创作者一起，让世界看到你的才华
        </p>
        <div className="flex items-center justify-center gap-4 flex-col sm:flex-row">
          <Link
            to="/about"
            className="whitespace-nowrap px-8 py-3 rounded-full bg-[oklch(var(--primary-500))] text-background-50 text-sm font-semibold hover:bg-[oklch(var(--primary-500)/0.85)] transition-colors cursor-pointer"
          >
            立即加入
          </Link>
          <Link
            to="/category/gaoxiao"
            className="whitespace-nowrap px-8 py-3 rounded-full bg-background-50/15 text-background-50 text-sm font-semibold border border-background-50/30 hover:bg-background-50/25 transition-colors cursor-pointer"
          >
            浏览视频
          </Link>
        </div>
      </div>
    </section>
  );
}